import React, { useEffect, useRef, useState } from 'react';
import { useInView, animate } from 'motion/react';

export function AnimatedNumber({ value }: { value: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, { once: true, margin: "0px" });
  const [displayValue, setDisplayValue] = useState(0);

  // Parse the value into prefix, number, and suffix
  // Handles strings like "600+", "$1.5M", "98%"
  const match = value.match(/^([^0-9\.]*)([0-9\.]+)([^0-9\.]*)$/);

  if (!match) {
    return <span>{value}</span>;
  }

  const [, prefix, numStr, suffix] = match;
  const num = parseFloat(numStr);
  const isFloat = numStr.includes('.');

  useEffect(() => {
    if (isInView) {
      const controls = animate(0, num, { 
        duration: 2, 
        ease: "easeOut",
        onUpdate: (latest) => setDisplayValue(latest)
      });
      return controls.stop;
    }
  }, [isInView, num]);

  return (
    <span ref={ref} className="inline-flex items-center justify-center">
      {prefix}
      <span>{isFloat ? displayValue.toFixed(1) : Math.round(displayValue)}</span>
      {suffix}
    </span>
  );
}
